<template>
<div class="container-fluid">
	<notification-toolbar heading="Notifications"></notification-toolbar>

	<div class="container" style="max-width: 800px;">
		<h2>Tradetraks News</h2>

		<article v-if="'id' in note" class="bg-white p-4" style="font-size: 15pt;line-height: 26pt">
			<h1>{{moment.utc(note.release_date,false,false,true).local().format("MMM D, YYYY")}}</h1>

			<div v-html="stripInlineEventHandlers(note.notes)"></div>
		</article>
		<p v-else>No news at the momnent...</p>

		<div class="d-flex flex-row justify-content-between">
			<div>
				<button v-if="page > 1" class="btn btn-light" v-on:click="newer">
					<i class="fa fa-chevron-left"></i>
					Newer
				</button>
			</div>
			<div>
				<button v-if="page < pageCount" class="btn btn-light" v-on:click="older">
					Older
					<i class="fa fa-chevron-right"></i>
				</button>
			</div>
		</div>
	</div>
</div>
</template>
<script type="text/javascript">
import NotificationToolbar from  "@/pages/notifications/NotificationToolbar"

export default {
	name: "NotificationCenter",
	components: {
		NotificationToolbar
	},
	mixins: [],
	data() {
		return {
			note: {},
			page: 1,
			pageCount: 0
		}
	},
	computed: {

	},
	methods: {
		newer() {
			this.page--

			this.fetchReleaseNote(true)
		},
		older() {
			this.page++

			this.fetchReleaseNote(true)
		},
		fetchReleaseNote(spinner) {
			let vm = this

			if (spinner)
				this.spinner(true)

			let params = {
				page: this.page,
				custom_page_limit: 1
			}

			return new Promise((resolve,reject) => {

				vm.getJSON("ReleaseNote/get",params,true).then(response => {
					if (response.success && response.data.length > 0) {
						vm.note = response.data[0]
						vm.pageCount = response.meta.num_pages
					}
					if (spinner)
						vm.spinner(false)

					resolve(response)
				})
			})
		},
		fetchData(spinner) {
			let vm = this

			let promises = [
				this.fetchNotifications(false,this.notificationLimit,this.showDismissed)
			]

			if (spinner)
				this.spinner(true)

			Promise.all(promises).then(responses => {
				if (spinner)
					vm.spinner(false)

				vm.notifications = responses[0].data

				vm.loading = false
			})
		}
	},
	created() {
		this.fetchReleaseNote(true)
	}
}
</script>